module.exports = __webpack_public_path__ + "img/nick-link-icon-secondary.cad94b5.png";